import React from 'react';
import StyledCarousel from 'views/rebranded-module/common/components/UI/Carousel/Carousel.styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSelector } from 'react-redux';

const responsive = (
  largedesktopItems,
  deskTopItems,
  tabletItem,
  mobileItem,
  mobilePartialVisibilityGutter,
  desktopPartialVisibilityGutter,
  largeDesktopPartialVisibilityGutter,
  tabletPartialVisibilityGutter,
) => ({
  largedesktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: largedesktopItems,
    partialVisibilityGutter: largeDesktopPartialVisibilityGutter, // this is needed to tell the amount of px that should be visible.
  },
  desktop: {
    breakpoint: { max: 1200, min: 1024 },
    items: deskTopItems,
    slidesToSlide: deskTopItems,
    partialVisibilityGutter: desktopPartialVisibilityGutter, // this is needed to tell the amount of px that should be visible.
  },
  tablet: {
    breakpoint: { max: 1023, min: 600 },
    items: tabletItem,
    slidesToSlide: 1,
    partialVisibilityGutter: tabletPartialVisibilityGutter,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: mobileItem,
    slidesToSlide: 1,
    partialVisibilityGutter: mobilePartialVisibilityGutter,
  },
});

const createArrowLeft = (carouselType) => (arrowLeftProps) => (
  <span {...arrowLeftProps} className="CArrow CArrowLeft">
    {carouselType === 'image-gallery' ? (
      <NavigateBeforeIcon className="CArrowIcon" />
    ) : (
      <ArrowBackIcon className="CArrowIcon" />
    )}
  </span>
);

const createArrowRight = (carouselType) => (arrowRightProps) => (
  <span {...arrowRightProps} className="CArrow CArrowRight">
    {carouselType === 'image-gallery' ? (
      <NavigateNextIcon className="CArrowIcon" />
    ) : (
      <ArrowForwardIcon className="CArrowIcon" />
    )}
  </span>
);

const Carousel = (props) => {
  const {
    children,
    deskTopItems,
    carouselArrow,
    mobilePartialVisibilityGutter = 30,
    tabletPartialVisibilityGutter = 20,
    tabletItem = 2,
    mobileItem = 1,
    desktopPartialVisibilityGutter = 0,
    largeDesktopPartialVisibilityGutter = 0,
    largedesktopItems = deskTopItems,
    showDots = true,
    arrowOutside = false,
    className,
    carouselType,
  } = props;
  const singleItemVisible = largedesktopItems === 1
    && deskTopItems === 1
    && tabletItem === 1
    && mobileItem === 1;
  const { isSSR, isCrawler, deviceType } = useSelector(
    (state) => state.globalData,
  );

  // Create arrow components based on carousel type
  const ArrowLeft = createArrowLeft(carouselType);
  const ArrowRight = createArrowRight(carouselType);

  return (
    <StyledCarousel
      arrowOutside={arrowOutside}
      className={`${className} ${arrowOutside ? 'CArrowOutside' : ''}`}
      partialVisible={children.length != 1}
      swipeable
      draggable={false}
      ssr={isSSR}
      deviceType={deviceType}
      keyBoardControl
      arrows={!isCrawler && carouselArrow}
      autoPlay={false}
      renderButtonGroupOutside
      containerClass="CCarouselContainer"
      itemClass={`CCarouselItem ${
        singleItemVisible ? 'CCarouselSingleItem' : ''
      }`}
      dotListClass="CDots"
      customLeftArrow={<ArrowLeft />}
      customRightArrow={<ArrowRight />}
      shouldResetAutoplay={false}
      showDots={showDots}
      responsive={responsive(
        largedesktopItems,
        deskTopItems,
        tabletItem,
        mobileItem,
        mobilePartialVisibilityGutter,
        desktopPartialVisibilityGutter,
        largeDesktopPartialVisibilityGutter,
        tabletPartialVisibilityGutter,
      )}
      customTransition="transform 200ms ease-in">
      {children}
    </StyledCarousel>
  );
};

export { Carousel };
